import { useState } from "react";

const imgFolder = "./img/exterior/";

export default function CarViewer() {
  const [modelSelected, setModel] = useState("m7");
  const [colorSelected, setColor] = useState("black");
  const [rimsSelected, setRims] = useState("r20");
  const [rimsToShow, setRimsToShow] = useState("r20");
  const [colorToshow, setColorToshow] = useState("Позолоченный черный");

  function onColorClick(colorClicked) {
    console.warn(colorClicked);
    setColor(colorClicked);
  }

  function onRimsClick(rimsClicked) {
    console.warn(rimsClicked);
    setRims(rimsClicked);
  }

  return (
    <>
      {/* <div className="header">AITO M7 Configurator Demo</div> */}

      <div className="configurator">
        <div className="configurator-preview">
          <VehicleImage
            model={modelSelected}
            color={colorSelected}
            rims={rimsSelected}
          />
        </div>

        <div className="configurator-parameters-wrapper">
          <div className="carCaption">
            {colorToshow?.toUpperCase()} {rimsToShow?.toUpperCase()}
          </div>
          <div className="configurator-parameters">
            <div className="configurator-parameters-section">
              <ColorSelector
                value="Black"
                onColorClick={() => {
                  onColorClick("black");
                  setColorToshow("Позолоченный черный");
                }}
                colorSelected={colorSelected}
              />
              <ColorSelector
                value="Cosmo Gray"
                onColorClick={() => {
                  onColorClick("cosmo gray");
                  setColorToshow("Космический серый");
                }}
                colorSelected={colorSelected}
              />
              <ColorSelector
                value="Gold"
                onColorClick={() => {
                  onColorClick("gold");
                  setColorToshow("Туманное золото");
                }}
                colorSelected={colorSelected}
              />
              <ColorSelector
                value="Iasur"
                onColorClick={() => {
                  onColorClick("iasur");
                  setColorToshow("Лазурно-синий");
                }}
                colorSelected={colorSelected}
              />
              {/* <ColorSelector value="Green" onColorClick={() => {onColorClick("green"); setColorToshow('');}} colorSelected={colorSelected} /> */}
              <ColorSelector
                value="White"
                onColorClick={() => {
                  onColorClick("white");
                  setColorToshow("Керамический белый");
                }}
                colorSelected={colorSelected}
              />
            </div>
            <div className="configurator-parameters-section">
              <RimsSelector
                value="R20"
                onRimsClick={() => {
                  onRimsClick("r20");
                  setRimsToShow("r20");
                }}
                rimsSelected={rimsSelected}
              />
              <RimsSelector
                value="R21"
                onRimsClick={() => {
                  onRimsClick("r21");
                  setRimsToShow("r21");
                }}
                rimsSelected={rimsSelected}
              />
            </div>
          </div>
          <div className="carCaption"></div>
        </div>
      </div>
    </>
  );
}

function VehicleImage({ model, color, rims }) {
  const imgName = `${model}/${color}_${rims}.png`;

  console.info(imgName);

  return (
    <img
      className="car-interior-image"
      src={`${imgFolder}${imgName}`}
      alt={`M7, ${color}, ${rims}`}
    />
  );
}

function ColorSelector({ value, onColorClick, colorSelected }) {
  const imgName = `m7_icons/${value.toLowerCase()}.png`;

  return (
    <img
      className={`configurator-parameters__color ${
        colorSelected === value?.toLowerCase() ? "active" : ""
      }`}
      src={`${imgFolder}${imgName}`}
      alt={value}
      onClick={onColorClick}
    />
  );
}

function RimsSelector({ value, onRimsClick, rimsSelected }) {
  const imgName = `m7_icons/rims_${value.toLowerCase()}.png`;

  return (
    <img
      className={`configurator-parameters__color ${
        rimsSelected === value?.toLowerCase() ? "active" : ""
      }`}
      src={`${imgFolder}${imgName}`}
      alt={value}
      onClick={onRimsClick}
    />
  );
}

// m7_black_r20_2.png
